import { RestAddress } from '../../../hooks/useAddress';
import { BillingAddress } from '../../../hooks/usePaymentMethods';

export const convertShippingAddressToBillingAddress = (
  shippingAddress: RestAddress
): BillingAddress => ({
  __typename: 'RestBillingAddress',
  id: shippingAddress.id || null,
  countryCode: shippingAddress.attributes.countryCode,
  extendedAddress: shippingAddress.attributes.addressLine2,
  locality: shippingAddress.attributes.city,
  postalCode: shippingAddress.attributes.postalCode,
  region: shippingAddress.attributes.state,
  streetAddress: shippingAddress.attributes.addressLine1
});
